import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { ParseDictionaryServant } from '../../servants/parse_dictionary_servant';

interface IWindowPlugins extends Window {
  ionic: {
    Platform: {
      device: () => {};
      grade: string;
      ua: string;
    };
    navigator: {
      connection: {
        type: string;
      };
      language: string;
    };
  };
  cordova: any;
}

declare const window: IWindowPlugins;
export class AboutDeviceController {
  private deviceInfo: Record<string, any> = {};
  $onInit() {
    let ionicPlatformDeviceProps = {};
    if (window.ionic.Platform) {
      ionicPlatformDeviceProps = {
        ..._4.omit({ ...window.ionic.Platform.device() }, ['available', 'isVirtual']),
        grade: _4.get(window.ionic.Platform, 'grade', 'unknown'),
        user_agent: _4.get(window.ionic.Platform, 'ua', 'unknown'),
        connection: _4.get(window.ionic.Platform, 'navigator.connection.type', 'unknown'),
        language: _4.get(window.ionic.Platform, 'navigator.language', 'en-US')
      };
    }
    this.deviceInfo = ParseDictionaryServant.transformKeys(ionicPlatformDeviceProps);
  }
  isMobile(): boolean {
    return PlatformUtility.isMobile();
  }

  isIOS(): boolean {
    return PlatformUtility.isIOS();
  }
}
export class AboutDeviceComponent implements ng.IComponentOptions {
  public controller: object = AboutDeviceController;
  public templateUrl: string = 'capability-ng-settings/src/about/components/about_device/about_device.html';
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/about/components/about_device/about_device.ts